import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS, LANGS } from "@/i18n/translations";

const LS_KEY = "prevenii.language";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "es";
    const saved = window.localStorage.getItem(LS_KEY);
    if (saved && TRANSLATIONS[saved]) return saved;
    const nav = (typeof navigator !== "undefined" && navigator.language) || "es";
    const base = nav.slice(0, 2).toLowerCase();
    return TRANSLATIONS[base] ? base : "es";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(LS_KEY, lang);
    } catch (e) {
      // ignore
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const setLang = (next) => {
    if (TRANSLATIONS[next]) setLangState(next);
  };

  const value = useMemo(
    () => ({ lang, setLang, t: TRANSLATIONS[lang] || TRANSLATIONS.es, langs: LANGS }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within a LanguageProvider");
  return ctx;
}
